import type { ReactElement } from 'react';
import { useState } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

function SalesTaxTooltip(): ReactElement {
  const [show, setShow] = useState(false);

  const showTooltip = () => {
    setShow(true);
  };
  const hideTooltip = () => {
    setShow(false);
  };

  return (
    <OverlayTrigger
      placement="top"
      show={show}
      overlay={(
        <Tooltip
          id="sales-tax-tooltip"
          className="c-signup-checkout__sales-tax-tooltip"
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
        >
          Taxes are calculated for each shipping address total
          based on the state to which the item(s) is shipped.
          We will add all applicable taxes to items shipped to
          AL, AR, AZ, CA, CO, CT, DC, FL, GA, HI, IA, ID, IL,
          IN, KS, KY, LA, MA, MD, ME, MI, MN, MO, MS, NC, ND,
          NE, NJ, NM, NV, NY, OH, OK, PA, RI, SC, SD, TX, UT,
          VA, VT, WA, WI, WV, and WY.
        </Tooltip>
      )}
    >
      <span
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        ⓘ
      </span>
    </OverlayTrigger>
  );
}

export default SalesTaxTooltip;
